import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { AuthModule } from '@modules/auth/auth.module';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { appRoutes } from './app.routes';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from '../environments/environment';
import { ToastrModule } from 'ngx-toastr';
import { CoreModule } from '@core/core.module';
import { ViewConfig } from '@config/view.config';
import { HttpErrorInterceptor } from '@interceptors/http-error.interceptor';
import { MockInterceptor } from '@interceptors/mock.interceptor';
import { AuthInterceptor } from '@interceptors/auth.interceptor';
import { TranslateModule } from '@ngx-translate/core';
import { AppTranslate } from '@config/multi-translate-http-loader';
import {
  translationMWInitializerFactory,
  TranslationMWService,
} from '@services/translation-middleware/translation-middleware.service';
import {
  sessionManagerInitializerFactory,
  SessionManagerService,
} from '@services/sessionManager/session-manager.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    // routes
    RouterModule.forRoot(appRoutes),
    HttpClientModule,
    BrowserModule,
    AuthModule,
    SharedModule,
    BrowserAnimationsModule,
    CoreModule,
    ToastrModule.forRoot(ViewConfig.TOASTR_CONFIG),
    TranslateModule.forRoot(AppTranslate.loader()),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: translationMWInitializerFactory,
      deps: [TranslationMWService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: sessionManagerInitializerFactory,
      deps: [Injector],
      multi: true,
    },
    {
      provide: Window,
      useValue: window,
    },
    // interceptors order is important!!
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    environment.mock
      ? {
          provide: HTTP_INTERCEPTORS,
          useClass: MockInterceptor,
          multi: true,
        }
      : [],
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
